import { cloneDeep } from "lodash";
import { FlightGenerationParams } from "../objects/flightGenerationParams";

export const getSeriesMinDate = (flights_generations_params: FlightGenerationParams[]): Date | null => {
    const dates: Date[] = [];
    flights_generations_params.forEach((flight_generation_params) => {
        const { start_date, end_date, is_daily, days, frequency } = flight_generation_params;
        if (start_date && end_date) {
            if (is_daily) {
                const date = cloneDeep(start_date);
                while (date <= end_date) {
                    // On vérifie que le jour de la semaine est bien sélectionné
                    if (days.includes(date.getDay() as 0 | 1 | 2 | 3 | 4 | 5 | 6)) {
                        dates.push(cloneDeep(date));
                    }
                    date.setDate(date.getDate() + 1);
                }
            } else {
                // Si la fréquence est autre, on itère sur les jours d'intervalle
                const date = cloneDeep(start_date);
                while (date <= end_date) {
                    // On vérifie que la date est bien comprise entre les dates de départ et de fin
                    if (date >= start_date && date <= end_date) {
                        dates.push(cloneDeep(date));
                    }
                    date.setDate(date.getDate() + Number(frequency === '' ? 1 : frequency));
                }
            }
        }
    });
    dates.sort((a, b) => a.getTime() - b.getTime());
    return dates.length> 0 ? dates[0]: null;
};